import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import * as types from '../../constants/actionTypes';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actions } from '../../actions/locationActions';
import { actions as userActions } from '../../actions/userActions';
import { actions as locationDashboardActions } from '../../actions/locationDashboardActions';
import { DEFAULT_PAGE_SIZE, MOBILE_WINDOW_BREAKPOINT, DATE_FORMAT, SortColumnsType } from '../../constants/constants';
import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import { Menu } from 'primereact/menu';
import Icon from '../Common/Icon';
import Notification from '../../components/Common/Notification';
import LoadingIndicator from '../Common/LoadingIndicator/LoadingIndicator';
import './LocationsListPage.scss';
import LocationDrawer from './LocationDrawer';
import LocationBaselinesDrawer from './LocationBaselinesDrawer';
import LocationUserAccessDrawer from './LocationUserAccessDrawer';
import { getDataTableSortFields, getSearchParamSortFields } from '../../helpers/sortHelper';
import Button from '../Common/Button';
import Modal from '../Common/Modal/Modal';
import DateRangePickerWrapper from '../Common/DateRangePicker/DateRangePickerWrapper';
import LocationFileManagerDrawer from '../Common/LocationFileManagerDrawer/LocationFileManagerDrawer';
import { Checkbox } from 'primereact/checkbox';
import Moment from 'moment';
import BulkUpdateAttributesDrawer from '../Common/BulkUpdateAttributesDrawer/BulkUpdateAttributesDrawer';
import LocationImportDrawer from './Import/LocationImportDrawer';
import AssignTasksDrawer from '../LocationDashboard/Widgets/AssignTasksDrawer';
import { getNullableOnChangeValue } from '../../helpers/multiselect';

const DRAWERS = {
	EditLocation: 'editLocation',
	Baselines: 'assignedBaseline',
	UserAccess: 'userAccess',
	AddLocationFile: 'addLocationFile',
	BulkUpdateAttributes: 'bulkUpdateAttributes',
	LocationImportDrawer: 'locationImportDrawer',
	AssignTasksDrawer: 'assignTasksDrawer',
};

const CHARACTER_LIMIT_ABBREVIATIONS_MAXIMUM = 900;

export class LocationsListPage extends React.Component {
	constructor(props, context) {
		super(props, context);

		if (this.props.subscriptionId) {
			const newLocation = {
				id: 0,
				name: '',
				abbreviation: '',
				isActive: true,
				openingDate: new Date(),
				brandName: '',
				managementCompanyName: '',
			};

			const defaultSearchParams = {
				subscriptionId: this.props.subscriptionId,
				name: '',
				abbreviations: '',
				isActive: true,
				brands: [],
				managementCompanies: [],
				pageSize: DEFAULT_PAGE_SIZE,
				pageNumber: 1,
				sortBy: 'name',
				sortDir: 'asc',
				returnAllResults: false,
				openingDateStart: null,
				openingDateEnd: null,
			};

			this.state = {
				windowWidth: window.innerWidth,
				locations: [],
				brands: [],
				managementCompanies: [],
				totalCount: 0,
				columnOrder: [],
				selectedLocation: newLocation,
				editLocation: newLocation,
				newLocation: newLocation,
				currentDrawerKey: '',
				isFormValid: true,
				isLoading: false,
				isSearching: false,
				errorMessage: '',
				defaultSearchParams: defaultSearchParams,
				searchParams: defaultSearchParams,
				showDateRangePicker: false,
				dateRange: {
					start: null,
					end: null,
					name: '',
				},
				bulkUpdateMode: false,
				checkedRows: [],
				allRowsChecked: false,
				bulkLocations: [],
				isExpanded: false,
			};
		}
	}

	async componentDidMount() {
		document.title = 'Admin - Locations';
		this.loadListFilters();
		this.search();
	}

	isMobile = () => {
		return this.props.windowWidth < MOBILE_WINDOW_BREAKPOINT;
	};

	loadListFilters = async () => {
		try {
			this.setState({ isLoading: true });
			const result = await this.props.actions.loadListFilters(this.props.subscriptionId);
			const payload = result.payload;
			if (result.type === types.LOAD_LOCATION_LIST_FILTERS_SUCCESS) {
				this.setState({
					brands: payload.brands,
					managementCompanies: payload.managementCompanies,
				});
			} else if (result.type === types.LOAD_LOCATION_LIST_FILTERS_FAILURE) {
				Notification('error', 'An Error Occurred', payload.message);
			}
		} catch (error) {
			Notification('error', 'An Error Occurred', error);
		} finally {
			this.setState({ isLoading: false });
		}
	};

	handleDatepickerClick = () => {
		this.setState({ isExpanded: true });
	};

	search = async () => {
		try {
			this.setState({ isSearching: true });

			if (this.isAbbreviationsValid() === false) {
				Notification(
					'error',
					'Character Limit Exceeded',
					`The character limit of ${CHARACTER_LIMIT_ABBREVIATIONS_MAXIMUM} has been exceeded for abbreviations`
				);
				return;
			}

			let brands = [];
			if (this.state.searchParams.brands.length > 0) {
				brands = this.state.searchParams.brands.map((item) => {
					return item.name;
				});
			}

			let managementCompanies = [];
			if (this.state.searchParams.managementCompanies.length > 0) {
				managementCompanies = this.state.searchParams.managementCompanies.map((item) => {
					return item.name;
				});
			}

			const params = {
				...this.state.searchParams,
				brands: brands,
				managementCompanies: managementCompanies,
				abbreviations: this.abbreviationsToArray(this.state.searchParams.abbreviations),
			};

			const result = await this.props.actions.searchLocations(params);
			const payload = result.payload;
			if (result.type === types.SEARCH_LOCATION_SUCCESS) {
				this.setState({ locations: payload.results, totalCount: payload.totalCount, columnOrder: payload.columnOrder });
			} else if (result.type === types.SEARCH_LOCATION_FAILURE) {
				Notification('error', 'An Error Occurred', payload.message);
			}
		} catch (error) {
			Notification('error', 'An Error Occurred', error);
		} finally {
			this.setState({ isSearching: false });
		}
	};

	//we want the user to have the option of searching by a comma-delimited or space-delimited list
	abbreviationsToArray = (abbreviations) => {
		if (!abbreviations) {
			return [];
		}

		if (abbreviations.includes(',')) {
			return abbreviations.split(',');
		}

		return abbreviations.split(' ');
	};

	isAbbreviationsValid = () => {
		if (this.state.searchParams.abbreviations && this.state.searchParams.abbreviations.length > CHARACTER_LIMIT_ABBREVIATIONS_MAXIMUM) {
			return false;
		}

		return true;
	};

	bulkInactiveLocations = async (locations) => {
		try {
			this.setState({ isSearching: true });
			const locationIds = locations.map((location) => {
				return location.id;
			});
			const result = await this.props.actions.bulkInactiveLocations(locationIds);
			const payload = result.payload;
			if (result.type === types.BULK_INACTIVE_LOCATIONS_SUCCESS) {
				this.loadListFilters();
				this.search();
			} else if (result.type === types.BULK_INACTIVE_LOCATIONS_FAILURE) {
				Notification('error', 'An Error Occurred', payload.message);
			}
		} catch (error) {
			Notification('error', 'An Error Occurred', error);
		} finally {
			this.setState({ isSearching: false });
		}
	};

	onAddNewClick = () => {
		this.setState({
			selectedLocation: null,
			editLocation: null,
			currentDrawerKey: DRAWERS.EditLocation,
		});
	};

	clearFilters = () => {
		this.setState({ searchParams: this.state.defaultSearchParams }, this.search);
	};

	filterChange = (e) => {
		let name = e.target.name;
		this.setState({ searchParams: { ...this.state.searchParams, [name]: e.target.value } });
	};

	abbreviationFilterChange = (e) => {
		this.setState({
			searchParams: {
				...this.state.searchParams,
				abbreviations: e.target.value,
			},
		});
	};

	onSearchBlur = () => {
		this.search();
	};

	keyUpFilter = (e) => {
		if (e.keyCode == 13) {
			this.search();
		}
	};

	selectRow = (e) => {
		if (e.value === null) {
			return;
		}

		const isEllipsisClick =
			e.originalEvent.target.className.indexOf('ellipsis-h') >= 0 || e.originalEvent.target.className.indexOf('ellipsis') >= 0;
		if (isEllipsisClick === true) {
			return;
		}

		const isCheckboxClick = e.originalEvent.target.className.indexOf('chkbox') >= 0;
		if (isCheckboxClick === true) {
			return;
		}

		// fires when user clicks a row in the datatable, but only on mobile do we show the menu
		// non mobile they need to click the actions button which calls onActionsClick
		if (this.state.windowWidth < 500) {
			this.setState({ selectedLocation: e.value, editLocation: e.value });
			this.menu.toggle(e.originalEvent);
		} else {
			this.onNameClick(e.value);
		}
	};

	onNameClick = (rowData) => {
		this.setState({ selectedLocation: rowData, editLocation: rowData, currentDrawerKey: '' }, () => {
			// because the drawer needs to be hidden and reshown for it to refresh
			this.setState({ currentDrawerKey: DRAWERS.EditLocation });
		});
	};

	nameTemplate = (rowData) => {
		return (
			<span className='datatable-link' onClick={() => this.onNameClick(rowData)}>
				{rowData.name}
			</span>
		);
	};

	openingDateTemplate = (rowData) => {
		return rowData.openingDate ? Moment.utc(rowData.openingDate).format(DATE_FORMAT) : '';
	};

	onActionsClick = (rowData, e) => {
		this.menu.toggle(e);
		this.setState({ selectedLocation: rowData, editLocation: rowData });
	};

	onActiveFilterChange = (e) => {
		const selectedValue = getNullableOnChangeValue(e);

		this.setState({ searchParams: { ...this.state.searchParams, isActive: selectedValue } }, () => {
			this.search();
		});
	};

	activeTemplate = (rowData) => {
		if (rowData.isActive) {
			return (
				<div className='text-success text-center'>
					<Icon name='check-circle' />
				</div>
			);
		} else {
			return (
				<div className='text-danger text-center'>
					<Icon name='times-circle' />
				</div>
			);
		}
	};

	actionTemplate = (rowData) => {
		return (
			<div className='text-center ellipsis' onClick={(e) => this.onActionsClick(rowData, e)}>
				<Icon name='ellipsis-h' />
			</div>
		);
	};

	menuOptionClick = (e) => {
		switch (e.item.value) {
			case DRAWERS.EditLocation:
			case DRAWERS.AddLocationFile:
			case DRAWERS.Baselines: {
				this.setState({ currentDrawerKey: e.item.value });
				break;
			}
			case DRAWERS.UserAccess: {
				this.setState({ currentDrawerKey: e.item.value });
				break;
			}
			default: {
				this.setState({ currentDrawerKey: '' });
			}
		}
	};

	onBrandChange = (e) => {
		this.setState({ searchParams: { ...this.state.searchParams, brands: e.value } }, () => {
			this.search();
		});
	};

	onManagementCompanyChange = (e) => {
		this.setState({ searchParams: { ...this.state.searchParams, managementCompanies: e.value } }, () => {
			this.search();
		});
	};

	onLocationDrawerSuccess = (assignTasksAfterPush) => {
		this.setState({ currentDrawerKey: '' });
		this.loadListFilters();
		this.search();
		if (assignTasksAfterPush) {
			this.setState({ currentDrawerKey: DRAWERS.AssignTasksDrawer });
		}
	};

	onLocationDrawerCancel = () => {
		this.setState({ currentDrawerKey: '' });
	};

	onMenuButtonClick = (e) => {
		this.drawerMenu.toggle(e);
	};

	onSaveAndSelectBaselinesClick = async (locationName) => {
		this.loadListFilters(); // Always fire and forget loadListFilters() as nothing depends on it
		if (!this.state.selectedLocation) {
			/**
			 * When no location is selected, we've just Added a new location, so
			 * we must wait for search to return and then lookup the new location by name.
			 * This has to be done before we can properly load the LocationBaselineDrawer.
			 */
			await this.search();
			const locations = this.state.locations;
			const selected = locations.find((x) => x.name === locationName);
			if (selected) {
				this.setState({ currentDrawerKey: DRAWERS.Baselines, selectedLocation: selected });
			} else {
				this.setState({ currentDrawerKey: '' });
			}
		} else {
			/**
			 * When an existing location is being edited, it is already selected, and
			 * we can simply set the currentDrawerKey without searching the list by name.
			 * We also don't need to wait for search() to return before doing that, so
			 * here we fire-and-forget.
			 */
			this.search();
			this.setState({ currentDrawerKey: DRAWERS.Baselines });
		}
	};

	renderDrawer = () => {
		const locationDrawerMenuButtons = [
			<button key='settings' type='button' className='btn btn-custom' onClick={this.onMenuButtonClick} alt='Location Menu'>
				<Icon name='cog' />
			</button>,
		];

		switch (this.state.currentDrawerKey) {
			case DRAWERS.Baselines: {
				return (
					<LocationBaselinesDrawer
						subscriptionId={this.props.subscriptionId}
						location={this.state.selectedLocation}
						onComplete={this.onLocationDrawerSuccess}
						onCancel={this.onLocationDrawerCancel}
						menuButtons={locationDrawerMenuButtons}
						currentDrawerKey={this.state.currentDrawerKey}
					/>
				);
			}
			case DRAWERS.UserAccess: {
				return (
					<LocationUserAccessDrawer
						subscriptionId={this.props.subscriptionId}
						locationId={this.state.selectedLocation ? this.state.selectedLocation.id : undefined}
						onComplete={this.onLocationDrawerSuccess}
						onCancel={this.onLocationDrawerCancel}
						menuButtons={locationDrawerMenuButtons}
						currentDrawerKey={this.state.currentDrawerKey}
					/>
				);
			}
			case DRAWERS.EditLocation: {
				return (
					<LocationDrawer
						subscriptionId={this.props.subscriptionId}
						locationId={this.state.selectedLocation ? this.state.selectedLocation.id : undefined}
						onSave={this.onLocationDrawerSuccess}
						onSaveAndSelectBaselines={this.onSaveAndSelectBaselinesClick}
						onCancel={this.onLocationDrawerCancel}
						menuButtons={locationDrawerMenuButtons}
						currentDrawerKey={this.state.currentDrawerKey}
					/>
				);
			}
			case DRAWERS.AddLocationFile: {
				return (
					<LocationFileManagerDrawer
						onComplete={this.onLocationDrawerSuccess}
						onCancel={this.onLocationDrawerCancel}
						locationKey={this.state.selectedLocation.locationKey}
						fileId={this.state.selectedFileId}
					/>
				);
			}
			case DRAWERS.BulkUpdateAttributes: {
				return (
					<BulkUpdateAttributesDrawer
						onComplete={this.onLocationDrawerSuccess}
						onCancel={this.onLocationDrawerCancel}
						selectedLocationIds={this.state.bulkLocations.map((l) => l.id)}
						subscriptionId={this.props.subscriptionId}
					/>
				);
			}
			case DRAWERS.LocationImportDrawer: {
				return (
					<LocationImportDrawer
						onComplete={this.onLocationDrawerSuccess}
						onCancel={this.onLocationDrawerCancel}
						subscriptionId={this.props.subscriptionId}
						locationActions={this.props.actions}
					/>
				);
			}
			case DRAWERS.AssignTasksDrawer: {
				return (
					<AssignTasksDrawer
						locationKey={this.state.selectedLocation.locationKey}
						locationDashboardActions={this.props.locationDashboardActions}
						onComplete={this.onLocationDrawerSuccess}
						onCancel={this.onLocationDrawerCancel}
					/>
				);
			}
			default: {
				return null;
			}
		}
	};

	onPageChange = (e) => {
		this.setState({ searchParams: { ...this.state.searchParams, pageNumber: e.page + 1 } }, () => {
			this.search();
		});
	};

	/**
	 * Get the exact selected objects from the list of options being set on column filter multi-selects
	 */
	getColumnFilterMultiSelectValues = (searchParamValues, columnFiltersValues) => {
		let results = [];
		if (searchParamValues && searchParamValues.length && columnFiltersValues && columnFiltersValues.length) {
			for (let i = 0; i < searchParamValues.length; i++) {
				const value = columnFiltersValues.find((m) => m.id.toString() === searchParamValues[i].id.toString());
				if (value) {
					results.push(value);
				}
			}
		}
		return results;
	};

	onSort = ({ sortField, sortOrder }) => {
		const { sortBy, sortDir } = getSearchParamSortFields(sortField, sortOrder);
		if (sortBy !== this.state.searchParams.sortBy || sortDir !== this.state.searchParams.sortDir) {
			this.setState(
				{
					searchParams: {
						...this.state.searchParams,
						sortBy: sortBy,
						sortDir: sortDir,
					},
				},
				this.search
			);
		}
	};

	showDateRangePicker = () => {
		this.setState({ showDateRangePicker: true });
	};

	onStartRangeChange = (startDate, endDate) => {
		const newDateRange = {
			...this.state.dateRange,
			start: startDate,
			end: endDate,
		};

		this.setState({ dateRange: newDateRange, isExpanded: true });
	};

	onDatePickerClick = () => {
		this.setState({ isExpanded: true });
	};

	onSelectDateRange = async () => {
		this.setState(
			{
				showDateRangePicker: false,
				searchParams: {
					...this.state.searchParams,
					openingDateStart: this.state.dateRange.start,
					openingDateEnd: this.state.dateRange.end,
				},
				isExpanded: false,
			},
			() => {
				this.search();
			}
		);
	};

	onCancelDateRange = () => {
		this.setState({ showDateRangePicker: false, isExpanded: false });
	};

	onToggleBulkUpdateMode = () => {
		this.setState({
			bulkUpdateMode: !this.state.bulkUpdateMode,
			// Reset checkbox states when toggling bulk update mode
			checkedRows: [],
			allRowsChecked: false,
			locations: this.state.locations.map(location => ({
				...location,
				isChecked: false
			}))
		});
	};

	onBulkUpdateInactive = () => {
		const locations = this.state.locations.filter((location) => location.isChecked == true);
		if (!locations || locations.length === 0) {
			Notification('error', '', 'You must have at least 1 location selected');
		} else {
			this.bulkInactiveLocations(locations);
		}
	};

	onUpdateAttributes = () => {
		const locations = this.state.locations.filter((location) => location.isChecked == true);
		if (!locations || locations.length === 0) {
			Notification('error', '', 'You must have at least 1 location selected');
		} else {
			this.setState({ showAttributesDrawer: true });
			this.setState({ currentDrawerKey: DRAWERS.BulkUpdateAttributes, bulkLocations: locations });
		}
	};

	onImport = () => {
		this.setState({ currentDrawerKey: DRAWERS.LocationImportDrawer });
	};

	checkboxTemplate = (rowData) => {
		return <Checkbox name='checkbox' onChange={() => this.onToggleCheckedRow(rowData.id)} checked={rowData.isChecked}></Checkbox>;
	};

	onMasterCheckboxToggle = () => {
		// Toggle the master checkbox to checked or unchecked
		const allRowsChecked = !this.state.allRowsChecked;

		// Check or uncheck all rows, based on the master checkbox's newly-toggled state
		const locations = this.state.locations.map((item) => {
			return { ...item, isChecked: allRowsChecked };
		});
		const checkedRows = allRowsChecked ? locations.slice() : [];

		this.setState({
			checkedRows: checkedRows,
			locations: locations,
			allRowsChecked: allRowsChecked,
		});
	};

	onToggleCheckedRow = (locationId) => {
		const locations = this.state.locations;
		let checkedRows = [];

		const newLocations = locations.map((item) => {
			let location = { ...item };
			if (item.id === locationId) {
				location.isChecked = !item.isChecked;
			}

			if (location.isChecked) {
				checkedRows.push(location);
			}
			return location;
		});

		// If we've manually checked all tasks, also check the master checkbox
		const allRowsChecked = newLocations.length === checkedRows.length;

		this.setState({
			checkedRows: checkedRows,
			locations: newLocations,
			allRowsChecked: allRowsChecked,
		});
	};

	onColumnReorder = async (e) => {
		const reorderedFields = e.columns.map((c) => c.props.field);

		const filtered = reorderedFields.filter((f) => f !== 'isChecked');

		const corrected = ['isChecked', ...filtered];

		this.setState({ columnOrder: corrected });

		await this.props.userActions.saveUsersColumns({
			columns: corrected,
			columnsType: SortColumnsType.AdminPageLocations,
		});
	};

	render = () => {
		const displayColumns = this.props.windowWidth < 500 ? 'none' : '';

		const activeOptions = [
			{ label: 'Yes', value: true },
			{ label: 'No', value: false },
			{ label: 'All', value: null },
		];
		const menuOptions = [
			{ label: 'View Location Profile', value: DRAWERS.EditLocation, command: this.menuOptionClick },
			{ label: 'View User Access', value: DRAWERS.UserAccess, command: this.menuOptionClick },
			{ label: 'View Baselines Applied', value: DRAWERS.Baselines, command: this.menuOptionClick },
			{ label: 'Add New File', value: DRAWERS.AddLocationFile, command: this.menuOptionClick },
		];
		const activeFilter = (
			<Dropdown
				appendTo={document.body}
				name='isActive'
				className='ui-column-filter'
				value={this.state.searchParams.isActive}
				options={activeOptions}
				onChange={this.onActiveFilterChange}
				optionLabel='label'
				optionValue='value'
			/>
		);
		const nameFilter = (
			<input
				type='text'
				name='name'
				placeholder='Name'
				className='p-inputtext'
				size='50'
				onBlur={this.onSearchBlur}
				onChange={this.filterChange}
				onKeyUp={this.keyUpFilter}
				value={this.state.searchParams.name}
			/>
		);
		const abbreviationFilter = (
			<input
				type='text'
				name='abbreviations'
				placeholder='Abbreviation'
				className='p-inputtext'
				size='300'
				onBlur={this.onSearchBlur}
				onChange={this.abbreviationFilterChange}
				onKeyUp={this.keyUpFilter}
				value={this.state.searchParams.abbreviations}
			/>
		);

		const selectedBrands = this.getColumnFilterMultiSelectValues(this.state.searchParams.brands, this.state.brands);
		const brandNameFilter = (
			<MultiSelect
				className='ui-column-filter'
				optionLabel='name'
				appendTo={document.body}
				dataKey='id'
				value={selectedBrands}
				options={this.state.brands}
				onChange={this.onBrandChange}
			/>
		);

		const selectedManagementCompanies = this.getColumnFilterMultiSelectValues(
			this.state.searchParams.managementCompanies,
			this.state.managementCompanies
		);
		const managementCompanyNameFilter = (
			<MultiSelect
				className='ui-column-filter'
				optionLabel='name'
				appendTo={document.body}
				dataKey='id'
				value={selectedManagementCompanies}
				options={this.state.managementCompanies}
				onChange={this.onManagementCompanyChange}
			/>
		);

		const openingDateFilter = (
			<div>
				<Button
					type='button'
					bootstrapClass='light'
					name='openingDateRangeButton'
					text={this.state.searchParams.openingDateStart || this.state.searchParams.openingDateEnd ? 'Edit Range' : 'Range'}
					onClick={() => this.showDateRangePicker()}
				/>
			</div>
		);

		/**
		 * Do not include the current drawer menu item from the context menu that shows
		 * when clicking the Cog Wheel icon in the menu bar of the drawers
		 */
		let drawerMenuOptions = menuOptions.filter((x) => x.value !== this.state.currentDrawerKey);

		const { sortField, sortOrder } = getDataTableSortFields(this.state.searchParams);

		const showToolbar = this.isMobile() ? false : true;
		const toolbar = (
			<div className='toolbar col-6'>
				{this.state.bulkUpdateMode ? (
					<Fragment>
						<div className='toolbar-item' onClick={this.onUpdateAttributes}>
							<Icon name='pencil-alt' />
							Update Attributes
						</div>
						<div className='toolbar-item' onClick={this.onBulkUpdateInactive}>
							<Icon name='minus-circle' />
							Inactive
						</div>
						<div className='toolbar-item' onClick={this.onToggleBulkUpdateMode}>
							<Icon name='dot-circle' />
							End Bulk Update
						</div>
					</Fragment>
				) : (
					<Fragment>
						<div className='toolbar-item' onClick={this.onToggleBulkUpdateMode}>
							<Icon name='dot-circle' />
							Bulk Update
						</div>
						<div className='toolbar-item' onClick={this.onImport}>
							<Icon name='file-upload' />
							Import
						</div>
						<div className='toolbar-item' onClick={this.clearFilters}>
							<Icon name='filter' />
							Clear Filters
						</div>
					</Fragment>
				)}
				<button type='button' className='btn btn-primary' onClick={this.onAddNewClick} alt='Add New'>
					<span className='me-2'>Add New</span>
					<Icon name='plus' />
				</button>
			</div>
		);

		const displayCheckboxColumn = this.state.bulkUpdateMode || this.state.locations.length === 0 ? '' : 'none';
		const masterCheckbox = (
			<Checkbox name='checkbox' onChange={() => this.onMasterCheckboxToggle()} checked={this.state.allRowsChecked}></Checkbox>
		);

		const getStaticColumns = () => {
			return [
				{
					className: 'checkbox-column',
					field: 'isChecked',
					filter: true,
					filterElement: masterCheckbox,
					body: this.checkboxTemplate,
					isSortable: false,
					reorderable: false,
					style: { textAlign: 'center', width: '40px', display: displayCheckboxColumn },
				},
				{
					field: 'name',
					header: 'Name',
					body: this.nameTemplate,
					filter: true,
					filterElement: nameFilter,
					isSortable: true,
				},
				{
					field: 'openingDate',
					header: 'Opening Date',
					body: this.openingDateTemplate,
					filter: true,
					filterElement: openingDateFilter,
					isSortable: true,
					style: { width: '130px' },
				},
				{
					field: 'abbreviation',
					header: 'Abbreviation',
					filter: true,
					filterElement: abbreviationFilter,
					isSortable: true,
				},
				{
					field: 'brandName',
					header: 'Brand',
					filter: true,
					filterElement: brandNameFilter,
					style: { display: displayColumns },
					isSortable: true,
				},
				{
					field: 'managementCompanyName',
					header: 'Management Company',
					filter: true,
					filterElement: managementCompanyNameFilter,
					style: { display: displayColumns },
					isSortable: true,
				},
				{
					field: 'isActive',
					header: 'Active',
					body: this.activeTemplate,
					style: { display: '120px' },
					filter: true,
					filterElement: activeFilter,
					isSortable: true,
				},
				{
					field: 'actions',
					header: 'Actions',
					body: this.actionTemplate,
					style: { width: '6em', display: displayColumns },
				},
			];
		};

		const buildColumnOptions = () => {
			const columns = getStaticColumns().slice();
			const selectedColumns = [];

			// Look for columns personalization, else use the default
			if (this.state.columnOrder && this.state.columnOrder.length > 0) {
				for (const uc of this.state.columnOrder) {
					const col = columns.find((c) => c.field === uc);
					if (col) {
						selectedColumns.push(col);
					}
				}
			} else {
				for (const col of columns) {
					selectedColumns.push(col);
				}
			}

			const cols = selectedColumns.map((col) => {
				return (
					<Column
						className={col.className}
						key={col.field}
						field={col.field}
						reorderable={col.reorderable}
						header={col.header}
						body={col.body}
						filter={col.filter}
						style={col.style}
						filterElement={col.filterElement}
						sortable={col.isSortable}
					/>
				);
			});

			return cols;
		};

		return (
			<div>
				<Menu model={menuOptions} popup={true} ref={(el) => (this.menu = el)} autoZIndex={false} baseZIndex={20001} />
				<Menu model={drawerMenuOptions} popup={true} ref={(el) => (this.drawerMenu = el)} autoZIndex={false} baseZIndex={20001} />
				<LoadingIndicator isLoading={this.state.isLoading || this.state.isSearching} hideWhileLoading={true}>
					<div className='location-list-toolbar'>
						{this.props.isSubPage ? (
							<div className='subpage-header'>
								<div className='identifier-header'>
									<div className='title'>Locations</div>
									{showToolbar && toolbar}
									<div className='close'>
										<button type='button' onClick={this.props.onClose} alt='close popup'>
											<Icon name='times' />
										</button>
									</div>
								</div>
							</div>
						) : (
							<div className='page-header row'>
								<div className='col-6'>
									<h4>Locations</h4>
								</div>
								<div className='col-6'>{showToolbar && toolbar}</div>
							</div>
						)}
						<div className='identifier-results-table'>
							<DataTable
								key={`${(this.state.columnOrder || []).filter(Boolean).join('-')}-${this.state.bulkUpdateMode}`}
								filterDisplay='row'
								className='p-datatable-sm p-datatable-striped'
								resizableColumns={true}
								columnResizeMode='fit'
								value={this.state.locations}
								selectionMode='single'
								reorderableColumns
								onColReorder={(e) => this.onColumnReorder(e)}
								selection={this.state.selectedLocation}
								onSelectionChange={this.selectRow}
								sortField={sortField}
								sortOrder={sortOrder}
								onSort={this.onSort}>
								{buildColumnOptions()}
							</DataTable>
							{this.state.totalCount > this.state.searchParams.pageSize && (
								<Paginator
									rows={this.state.searchParams.pageSize}
									totalRecords={this.state.totalCount}
									first={(this.state.searchParams.pageNumber - 1) * this.state.searchParams.pageSize}
									onPageChange={this.onPageChange}
								/>
							)}
							<div className='results-count'>Total records: {this.state.totalCount}</div>
						</div>
					</div>
				</LoadingIndicator>
				{this.renderDrawer()}
				{this.state.showDateRangePicker ? (
					<Modal
						id='startDateRangeModal'
						title='Select Date Range'
						body={
							<div
								style={{
									height: this.state.isExpanded ? '360px' : 'auto',
									transition: 'height 0.3s ease',
								}}
								className='datepicker-wrapper'>
								<DateRangePickerWrapper
									onDatesChange={this.onStartRangeChange}
									initialStartDate={this.state.dateRange.start}
									initialEndDate={this.state.dateRange.end}
									onDatePickerClick={this.onDatePickerClick}
								/>
							</div>
						}
						primaryButtonText='Apply'
						onPrimaryClick={this.onSelectDateRange}
						onSecondaryClick={this.onCancelDateRange}
						onCloseClick={this.onCancelDateRange}
					/>
				) : null}
			</div>
		);
	};
}
LocationsListPage.propTypes = {
	windowWidth: PropTypes.number.isRequired,
	locationDashboardActions: PropTypes.object.isRequired,
	userActions: PropTypes.object.isRequired,
	actions: PropTypes.object.isRequired,
	subscriptionId: PropTypes.string,
	isSubPage: PropTypes.bool,
	onClose: PropTypes.func,
};

function mapStateToProps(state, ownProps) {
	let subscriptionId = null;

	if (ownProps.subscriptionId && ownProps.isSubPage) {
		subscriptionId = ownProps.subscriptionId.toString();
	} else if (ownProps.match.params.subscriptionId) {
		subscriptionId = ownProps.match.params.subscriptionId;
	}

	return {
		windowWidth: state.window.width,
		subscriptionId: subscriptionId,
	};
}

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(actions, dispatch),
		locationDashboardActions: bindActionCreators(locationDashboardActions, dispatch),
		userActions: bindActionCreators(userActions, dispatch),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(LocationsListPage);
